/**
 * Form redirect — Globo Form Builder integration
 *
 * On form submit, reads two `.health-goal-question` radio groups and
 * redirects based on matched entries in window.FormRedirectMap (injected
 * by Liquid from the `waar_wil_je_vooral_op_focussen` metaobject).
 *
 * Containers are identified by their radio values, not DOM order:
 *   - Anticonception container: radios with value anticonception-yes/no
 *   - Goal container: all other radios
 *
 * Match priority:
 *   1. optionValue + anticonception both match
 *   2. optionValue matches and anticonception is "None" (second Q ignored)
 *
 * No redirect occurs when no match is found — form shows success normally.
 */

(function () {
  var entries = /** @type {any} */ (window).FormRedirectMap;
  if (!Array.isArray(entries) || !entries.length) return;

  var ANTICONCEPTION = ['anticonception-yes', 'anticonception-no'];

  function checkedValue(/** @type {Element} */ container) {
    var radio = container.querySelector('input[type="radio"]:checked');
    return radio ? /** @type {HTMLInputElement} */ (radio).value : null;
  }

  function isAnticonceptionContainer(/** @type {Element} */ container) {
    var radios = container.querySelectorAll('input[type="radio"]');
    return radios.length > 0 && Array.prototype.every.call(radios, function (/** @type {Element} */ r) {
      return ANTICONCEPTION.indexOf(/** @type {HTMLInputElement} */ (r).value) !== -1;
    });
  }

  document.addEventListener('globo.formbuilder.form.submitted', function (event) {
    var e = /** @type {CustomEvent<{ form?: Element }>} */ (event);
    var root = /** @type {Element | Document} */ (
      e.detail && e.detail.form instanceof Element ? e.detail.form : document
    );

    var containers = root.querySelectorAll('.health-goal-question');
    if (!containers.length && root !== document) {
      containers = document.querySelectorAll('.health-goal-question');
    }

    var goalContainer = null;
    var antiContainer = null;

    Array.prototype.forEach.call(containers, function (/** @type {Element} */ c) {
      if (isAnticonceptionContainer(c)) antiContainer = c;
      else goalContainer = c;
    });

    if (!goalContainer) return;

    var goalValue = checkedValue(goalContainer);
    if (!goalValue) return;

    var antiValue = antiContainer ? checkedValue(antiContainer) : null;

    // Exact match: optionValue + anticonception
    var match = antiValue && entries.find(function (/** @type {{ optionValue: string, anticonception: string, url: string }} */ r) {
      return r.optionValue === goalValue && r.anticonception === antiValue;
    });

    // Fallback: anticonception = "None" (second question does not affect redirect)
    if (!match) {
      match = entries.find(function (/** @type {{ optionValue: string, anticonception: string, url: string }} */ r) {
        return r.optionValue === goalValue && r.anticonception === 'None';
      });
    }

    if (match && match.url) window.location.href = match.url;
  });
})();
